import { render } from "./ProveedorCreate.vue?vue&type=template&id=740422ef&scoped=true"
import script from "./ProveedorCreate.vue?vue&type=script&lang=js"
export * from "./ProveedorCreate.vue?vue&type=script&lang=js"

import "./ProveedorCreate.vue?vue&type=style&index=0&id=740422ef&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740422ef"]])

export default __exports__